export default __webpack_public_path__ + "static/LT-aabf912784b9fe6b4d2ce77166dba4fe.jpg";